/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespCollectionsComponents_collectionsModules = {
    readonly gridType: string | null;
    readonly " $refType": "SbRespCollectionsComponents_collectionsModules";
};
export type SbRespCollectionsComponents_collectionsModules$data = SbRespCollectionsComponents_collectionsModules;
export type SbRespCollectionsComponents_collectionsModules$key = {
    readonly " $data"?: SbRespCollectionsComponents_collectionsModules$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespCollectionsComponents_collectionsModules">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespCollectionsComponents_collectionsModules",
  "type": "CollectionsModulesMainContent",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "gridType",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = 'b673457bbc18d4bffd6a0f1431cad0b3';
export default node;
